import { render, staticRenderFns } from "./ProfileDataTable.vue?vue&type=template&id=abfedaea&"
import script from "./ProfileDataTable.vue?vue&type=script&lang=js&"
export * from "./ProfileDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports